import httpClient from "../../../client/httpClient";
import { renameFileWithUUID } from "../../../utils/renameFileWithUUID";

export const fetchSellerBanners = async (sellerId) => {
    try {
        const res = await httpClient.get(`v1/api/seller/seller-banner/get-seller-id/${sellerId}`);
        const sortedSellerBanners = res.data.sort((a, b) => b.id - a.id);
        return sortedSellerBanners;
    } catch (error) {
        console.log("Error on fetching seller banners", error);
        return Promise.reject(error);
    }
};

export const createSellerBanner = async ({ sellerId, name, image }) => {
    try {
        const formData = new FormData();
        formData.append("link", "");
        formData.append("banner", name);
        formData.append("sellerId", sellerId);

        const renamedImage = renameFileWithUUID(image.source);
        formData.append("bannerImage", renamedImage);

        const res = await httpClient.post("v1/api/seller/seller-banner/save", formData);
        return res.data;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};

export const updateSellerBanner = async ({ id, name, image }) => {
    try {
        const formData = new FormData();
        formData.append("link", "");
        formData.append("banner", name);

        if (image.source) {
            const renamedImage = renameFileWithUUID(image.source);
            formData.append("bannerImage", renamedImage);
        }

        const res = await httpClient.put(`v1/api/seller/seller-banner/update/${id}`, formData);

        return res.data;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};

export const deleteSellerBanner = async (bannerId) => {
    try {
        await httpClient.delete(`v1/api/seller/seller-banner/delete-by-id/${bannerId}`);
        return bannerId;
    } catch (error) {
        console.log("Error on creating banner", error);
        throw error;
    }
};
